import React from "react";
import styled from "styled-components";
import peerTalkFireIcon from "./images/peerTalkFireIcon.png";
import peerTalkLoveIcon from "./images/peerTalkLoveIcon.png";
import peerTalkShirtIcon from "./images/peerTalkShirtIcon.png";
import peerTalkBooksIcon from "./images/peerTalkBooksIcon.png";

const PeerTalkIcons = () => {
  return (
    <>
      <IconsContainer>
        <img width="50" src={peerTalkFireIcon} />
        <img width="50" src={peerTalkLoveIcon} />
        <img width="50" src={peerTalkShirtIcon} />
        <img width="50" src={peerTalkBooksIcon} />
      </IconsContainer>
    </>
  );
};

export default PeerTalkIcons;

const IconsContainer = styled.div`
  display: flex;
  align-senf: center;
  justify-content: space-around;
`;
